var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 165,
    viewBox: "0 0 164 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 0C127.255 0 164 36.9692 164 82.5V165H82C36.7452 165 0 128.031 0 82.5C0 36.9692 36.7452 0 82 0Z",
    fill: "#383649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.425 70.5166C110.218 57.982 99.8936 49.3149 84.2169 49.3149C68.7818 49.3149 57.4213 57.8439 57.4903 70.6547C57.4558 81.0829 64.8108 87.0221 76.7238 89.9227L84.4586 91.8218C92.1588 93.721 96.5097 95.9655 96.5442 100.765C96.5097 106.083 91.5373 109.64 83.837 109.64C76.0332 109.64 70.3702 106.083 69.8867 98.9696H55.6257C56.0401 114.094 66.9517 122.001 84.0097 122.001C101.24 122.001 111.323 113.749 111.392 100.834C111.323 89.0249 102.311 82.8439 90.2251 80.116L83.837 78.5622C77.7251 77.1464 72.442 74.8674 72.5456 69.6878C72.5456 65.0262 76.6892 61.6077 84.1133 61.6077C91.2956 61.6077 95.75 64.8881 96.3025 70.5166H110.425Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/S.361d247cc4993c9a63be4431b19b59b8.svg";
export { ForwardRef as ReactComponent };